import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../components/card/card";
import ImageViewer from "../../../components/ImageViewer";
import { printDate, printLocation } from "../../../utils/helper";
import React, { useState, useEffect } from "react";
import { companyProfile } from "../../../api";
import { parserAPI } from "../../../utils/parser";
import PlantProfile from "./PlantProfile";
import ZoneProfile from "./ZoneProfile";
import AreaProfile from "./AreaProfile";

function LocationConfiguration() {
  const [company, setCompany] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [location_wording, setLocation_wording] = useState([]);
  async function getCompany() {
    try {
      const res = await companyProfile.list();
      const data = await parserAPI(res);
      const loc = data.location_wording.split(",");
      setLocation_wording(loc);
      setCompany(data);
    } catch (e) {
      console.error(e);
    }
  }
  useEffect(() => {
    getCompany();
  }, []);
  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Setup</a>
            </li>
            <li className="breadcrumb-item active">Location</li>
          </ol>
          <h1 className="page-header mb-0">Location</h1>
        </div>
      </div>

      <div className="row gx-4">
        <div className="col-lg-12">
          <Card className="mb-4">
            <CardHeader>Update Location</CardHeader>
            <CardBody>
              <ul className="nav nav-tabs pt-3 ps-4 pe-4">
                {location_wording.map((item, index) => {
                  return (
                    <li className="nav-item me-1" key={index}>
                      <a
                        href={"#tab" + index}
                        className={index == 0 ? "nav-link active" : "nav-link"}
                        data-bs-toggle="tab"
                        onClick={() => setSelectedIndex(index)}
                      >
                        {item} Settings
                      </a>
                    </li>
                  );
                })}
              </ul>
              <div className="tab-content pt-3">
                <div className={"tab-pane fade show active"}>
                  {selectedIndex === 0 && <PlantProfile />}
                  {selectedIndex === 1 && <ZoneProfile />}
                  {selectedIndex === 2 && <AreaProfile />}
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
export default LocationConfiguration;
